import { h } from 'preact'
import Icon from '../../assets'

export const EnableTicketSyncInZendeskWarning = () => (
  <div className='warning-box'>
    <Icon customClass='icon-warning' icon='warning' />
    We still miss some data source to display the full dashboard, please <a target='blank' href='/settings/integrations/zendesk' >setup Zendesk integration</a> and enable ticket data sync.
  </div>
)
